import { PreferenceDto } from '@creditsights/api-ui-web';
import { Button, Icon, ICONS } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import { RecentSearch } from '../../../../../models/RecentSearch';
import { RowSelection } from '../../SearchSuggest/SearchSuggest.constants';
import styles from './RecentSearchList.module.scss';

const cx = classNames.bind(styles);

interface RecentSearchesListProps {
  recentSearches: PreferenceDto<RecentSearch[]>;
  verticalIndex: number | null;
  onSuggestionClick: (selectedTerm: string, category: string) => void;
  removeRecentSearch: (searchTerm: string) => void;
  savedSearchesCount?: number;
  horizontalIndex: 0 | 1;
}

const RecentSearchesList = ({
  recentSearches,
  verticalIndex,
  savedSearchesCount,
  onSuggestionClick,
  removeRecentSearch,
  horizontalIndex,
}: RecentSearchesListProps): React.ReactElement => {
  const getSelectedItem = (index: number): RowSelection => {
    if ((savedSearchesCount ?? 0) + index === verticalIndex) {
      return horizontalIndex === 0 ? RowSelection.Item : RowSelection.Button;
    }
    return RowSelection.None;
  };
  return (
    <div className={cx('body')}>
      {recentSearches.value.map((recentSearch, index) => (
        <div
          className={cx('recent-search-item')}
          key={recentSearch.searchTerm}
          data-row-selection={getSelectedItem(index)}
          data-testid="recent-search-item"
        >
          <div
            className={cx('recent-search-title-container')}
            onClick={() => onSuggestionClick(recentSearch.searchTerm, recentSearch.category ?? 'All')}
            data-testid="recent-search-title-container"
          >
            <p className={cx('recent-search-title')}>{recentSearch.searchTerm}</p>
          </div>
          <Button
            className={cx('recent-search-remove-btn')}
            data-remove="remove-recent-search"
            onClick={() => removeRecentSearch(recentSearch.searchTerm)}
            ariaLabel="remove recent search"
          >
            <Icon name={ICONS.Delete} />
          </Button>
        </div>
      ))}
    </div>
  );
};

export default RecentSearchesList;
